export const isIE = () => {
    return /*@cc_on!@*/false || !!document.documentMode;
}

export const setInternalServerError = error => {
    console.error('Error:', error?.message ?? error);
    window.location.href = '/internal-server-error';
}

export const hasScrollBar = element => element.scrollHeight > element.clientHeight;

export const isNullOrEmpty = str => str == null || str === "";
export const isNullOrWhiteSpace = str => str == null || str.toString().trim() === "";


export const getValueByInputType = (e) => getValue(e);

export const getValue = (event) => {
    switch (event.target.type) {
        case "number": return getValue.Number(event);
        case "checkbox":
        case "boolean": return getValue.Bool(event);
        default: return getValue.String(event);
    }
};
getValue.Number = event => {
    const value = event?.target.value;
    if (event.target.keepInvalid && value != "" && (isNaN(value) || (value != null && value[value.length - 1] == "."))) {
        return value;
    }
    return value == null || value === "" ? null : Number(value);
}
getValue.Bool = ({ target }) => target.checked == null
    ? target.value
    : target.checked;

getValue.String = ({ target }) => target.value == null || target.value == ""
    ? ""
    : target.value;

export const getBaseRequest = (url, header) => {
    if (header == null) {
        header = {
            method: 'GET'
        };
    }
    return new Request(url, {
        ...header
    });
}